import script from "./ProductHardDetail.vue?vue&type=script&setup=true&name=ProductHardDetail&lang=js"
export * from "./ProductHardDetail.vue?vue&type=script&setup=true&name=ProductHardDetail&lang=js"

import "./ProductHardDetail.vue?vue&type=style&index=0&id=e2136708&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e2136708"]])

export default __exports__